export default __webpack_public_path__ + "static/media/title_output.b28eaab1.png";